import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { pad } from './miscHelpers';

dayjs.extend(customParseFormat);

export const isValid = (date) => !!(date && dayjs(date).isValid());

// Used to validate birthdays
export const isDayMonthYearADate = (day, month, year) => {
  if (!day || !month || !year) {
    return false;
  }
  const dateString = convertDayMonthYearToDate(day, month, year);

  return dayjs(dateString, 'YYYY-MM-DD', true).isValid();
};

export const subtractADay = (date) => dayjs(date).subtract(1, 'day').toDate();

export const convertISODateTimeStringToISODateNoTimeZone = (date, time, t) => {
  const dateTime = `${date} ${time}`;
  if (!dayjs(dateTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }
  return dayjs(dateTime, 'YYYY-MM-DD HH:mm:ss').toISOString();
};

export const convertISODateTimeStringToISODate = (date, time, timeZone, t) => {
  const dateTime = `${date} ${time}`;
  if (!dayjs(dateTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }
  return dayjs.tz(dateTime, 'YYYY-MM-DD HH:mm:ss', timeZone).toISOString();
};

export const getClientTimezone = () => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  return timeZone;
};

// export const convertUTCDateTimeStringToISODate = (date, time) => {
//   const dateTime = `${date} ${time}`;
//   if (moment(dateTime, 'MMM D, YYYY h:mm a', true).isValid())
//     return moment.tz(dateTime, 'MMM D, YYYY h:mm a', 'UTC').toISOString();
//   return null;
// };

export const convertDateTimeStringToISODate = (date, time, timeZone, t) => {
  const dateTime = `${date} ${time}`;
  if (!dayjs(dateTime, 'MMM D, YYYY h:mm a', true).isValid()) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }
  return dayjs.tz(dateTime, 'MMM D, YYYY h:mm a', timeZone).toISOString();
};

// export const convertDateStringToMomentDate = (date) => {
//   if (moment(date, 'MMM D, YYYY', true).isValid())
//     return moment(date, 'MMM D, YYYY');
//   return null;
// };

export const convertDateStringToISODate = (date, t) => {
  if (!dayjs(date, 'MMM D, YYYY', true).isValid()) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }

  return dayjs(date, 'MMM D, YYYY').format('YYYY-MM-DD');
};

// export const convertShipCompliantTimeTOISODate = (time, settings) => {
//   const dateTime = `2018-01-01 ${time}`;
//   if (moment(dateTime, 'YYYY-MM-DD HH:mm:ss', true).isValid())
//     return moment
//       .tz(dateTime, 'YYYY-MM-DD HH:mm:ss', timeZone(settings))
//       .toISOString();
//   return null;
// };

export const convertDayMonthYearToDate = (day, month, year) => {
  // Used to convert b-days
  const dateString = `${pad('0000', year)}-${pad('00', month)}-${pad(
    '00',
    day
  )}`;
  return dateString;
};

// export const dateAddDay = (date, days, settings) => {
//   if (!isValid(date)) {
//     throw new Error('Invalid Date');
//   }
//   return moment(date)
//     .tz(timeZone(settings))
//     .add(days, 'days')
//     .format('YYYY-MM-DD');
// };

// export const dateFormatNoTimeZone = (date, format) => {
//   if (!isValid(date)) {
//     throw new Error('Invalid Date');
//   }
//   switch (format) {
//     case 'isoDate':
//       return moment(date).format('YYYY-MM-DD');
//     default:
//       return moment(date).format('MMM D, YYYY');
//   }
// };

export const dateFormatNoTimeZone = (date, format, t) => {
  if (!isValid(date)) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }

  switch (format) {
    case 'isoDate':
      return dayjs(date).format('YYYY-MM-DD');
    default:
      return dayjs(date).format('MMM D, YYYY');
  }
};

export const dateFormat = (t, date, timeZone, format) => {
  if (!isValid(date)) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }

  switch (format) {
    case 'isoDate':
      return dayjs(date).tz(timeZone).format('YYYY-MM-DD');
    default:
      return dayjs(date).tz(timeZone).format('MMM D, YYYY');
  }
};

export const timeFormat = (t, date, timeZone, format) => {
  if (!isValid(date)) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }
  switch (format) {
    case 'isoDate':
      return dayjs(date).tz(timeZone).format('HH:mm:ss');
    case 'isoDateNoSeconds':
      return dayjs(date).tz(timeZone).format('HH:mm');
    default:
      return dayjs(date).tz(timeZone).format('h:mm a');
  }
};

// export const timeZone = (settings) => settings.timeZone;

export const validateMinimumAge = (
  birthDay,
  birthMonth,
  birthYear,
  settings
) => {
  const { minimumAge } = settings;
  const birthDate = new Date();
  birthDate.setFullYear(birthYear, birthMonth - 1, birthDay);

  const ageCheck = new Date();

  // this is the min age the customer must be
  ageCheck.setFullYear(ageCheck.getFullYear() - minimumAge);

  if (ageCheck - birthDate < 0) {
    return false;
  }

  return true;
};

export const isValidBirthDate = (birthDay, birthMonth, birthYear) => {
  const birthDate = new Date();
  birthDate.setFullYear(birthYear, birthMonth - 1, birthDay);
  const yearCheck = birthDate.getFullYear();
  if (yearCheck < 1900) {
    return false;
  }
  return true;
};

// export const timeOnlyFormat = (time) => {
//   if (!time) {
//     throw new Error('Invalid Date');
//   }
//   if (moment(time, 'HH:mm:ss', true).isValid())
//     return moment(time, 'HH:mm:ss').format('h:mm a');

//   throw new Error('Invalid Date');
// };

export const dayFormat = (t, date, timeZone) => {
  if (!isValid(date)) {
    throw new Error(t('general.errorMessages.invalidDate'));
  }
  return dayjs(date).tz(timeZone).format('ddd');
};

// export const dayOfWeekAsString = (day) =>
//   [
//     'Sunday',
//     'Monday',
//     'Tuesday',
//     'Wednesday',
//     'Thursday',
//     'Friday',
//     'Saturday'
//   ][day];

// export const dayOfWeekAsString = (day) =>
//   [
//     'Sunday',
//     'Monday',
//     'Tuesday',
//     'Wednesday',
//     'Thursday',
//     'Friday',
//     'Saturday'
//   ][day];
